export default __webpack_public_path__ + "static/media/addyDesignService.3b721fc4.png";